/**
  * user模块接口列表
  */

//  import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const user = {
 //登录接口
  login: params => { 
    return axios.post('/authorization/login/login',qs.stringify(params));
  },
  //登出
  logout(params) {
    return axios.post('/authorization/login/logout',qs.stringify(params));
  },
  // 创意列表
  // getPlanListDetail (params) {
  //     return axios.post('/inv-innovatemanager/plan/planList',qs.stringify(params));
  // },
  // vss登录接口
  loginVss: params => {
    // return axios.post('/authorization/login/supplierLogin',qs.stringify(params));
    return axios({
      method: 'post',
      url: '/authorization/login/supplierLogin',
      data: qs.stringify(params),
      timeout: 1000 * 60 * 2,
    });
  },
  //修改密码
  changePassword(params) {
    return axios.post('/authorization/participants/changePassword',qs.stringify(params));
  },
}

export default user;



// WEBPACK FOOTER //
// ./src/api/api_user.js